var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getHeaders } from "../utils/apiUtils";
/**
 * Generates Kult 18-01 report as JSON data (inline preview).
 */
export var generateKult1801Report = function (kyInstance, params) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post("reports/kult-18-01", {
                    json: params,
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Report error: ".concat(response.status));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, (_a.sent())];
        }
    });
}); };
/**
 * Starts the Kult 18-01 XLSX export. The agency generates it in the background (DB-876): the answer is the job
 * (HTTP 202), its state is polled with {@link fetchReportJob} and the file fetched with {@link downloadReportJobFile}.
 */
export var startKult1801XlsxJob = function (kyInstance, params) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post("reports/kult-18-01/export", {
                    json: params,
                    headers: getHeaders(),
                    searchParams: { format: "XLSX" },
                })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Report error: ".concat(response.status));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, (_a.sent())];
        }
    });
}); };
/**
 * Reads the state of an agency report job.
 *
 * @param kyInstance okapi ky instance
 * @param jobId id returned by the export request
 * @param signal aborts the request (component unmounted)
 * @returns the job state
 */
export var fetchReportJob = function (kyInstance, jobId, signal) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.get("reports/jobs/".concat(jobId), {
                    headers: getHeaders(),
                    signal: signal,
                })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw Object.assign(new Error("Report job error: ".concat(response.status)), {
                        response: response,
                    });
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, (_a.sent())];
        }
    });
}); };
var fileNameFromDisposition = function (header) {
    if (!header)
        return null;
    var encoded = /filename\*=(?:UTF-8'')?([^;]+)/i.exec(header);
    if (encoded) {
        try {
            return decodeURIComponent(encoded[1].trim().replace(/^"|"$/g, ""));
        }
        catch (_a) {
            // fall through to the plain filename
        }
    }
    var plain = /filename="?([^";]+)"?/i.exec(header);
    return plain ? plain[1].trim() : null;
};
/**
 * Downloads the file of a finished agency report job and triggers the browser save.
 *
 * @param kyInstance okapi ky instance
 * @param jobId id of a job in status DONE
 * @param fallbackFileName name used when the response carries no Content-Disposition
 */
export var downloadReportJobFile = function (kyInstance, jobId, fallbackFileName) { return __awaiter(void 0, void 0, void 0, function () {
    var response, fileName, blob, url, link;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, kyInstance.get("reports/jobs/".concat(jobId, "/file"), {
                    headers: getHeaders(),
                })];
            case 1:
                response = _c.sent();
                if (!response.ok) {
                    throw new Error("Download error: ".concat(response.status));
                }
                fileName = (_b = (_a = fileNameFromDisposition(response.headers.get("Content-Disposition"))) !== null && _a !== void 0 ? _a : fallbackFileName) !== null && _b !== void 0 ? _b : "report-".concat(jobId);
                return [4 /*yield*/, response.blob()];
            case 2:
                blob = _c.sent();
                url = URL.createObjectURL(blob);
                link = document.createElement("a");
                link.href = url;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                setTimeout(function () { return URL.revokeObjectURL(url); }, 100);
                return [2 /*return*/];
        }
    });
}); };
